define((require) => {
    "use strict";

    const _                 = require("underscore");
    const Preconditions     = require("shared/util/Preconditions");
    const Sorting           = require("ui/dashboard/Sorting");
    const Storage           = require("shared/services/Storage");

    /**
     *
     * @class SortingHelperMethods
     */
    const SortingHelperMethods = {
        current: (storageKey, sortingKey, sortingEnum, sortingDefault) => {
            return function() {
                const currentValue = Storage.Local.get(storageKey, sortingKey);

                if (currentValue) {
                    return sortingEnum.fromValue(currentValue);
                }

                return sortingDefault;
            };
        },

        set: (storageKey, sortingKey) => {
            return function(value) {
                Preconditions.checkState(_.isString(value) || value instanceof Sorting);

                const storageValue = _.isString(value) ? value : value.value;

                Storage.Local.update(storageKey, sortingKey, storageValue);
            };
        },

        fromValue: (sortingEnum) => {
            return function(value) {
                return sortingEnum.lookup(value);
            };
        }
    };

    return SortingHelperMethods;
});



// WEBPACK FOOTER //
// ./src/editor/ui/dashboard/SortingHelperMethods.js